
<template>
  <div class="adv-counter">
    <div class="wrapper-number">
      <div v-for="number in arr" :key="'number-'+Math.random()+number" class="text-number">
          {{number}}
      </div>
    </div>
    <div class="title-text">{{titile}}</div>
  </div>
</template>

<script>
export default {

    name: 'AdvCounter',

    props: {
      arr: {
        required: true
      },
      titile: {
        type: String,
        required: false
      }
    },

    computed: {
      
    },
}
</script>

<style>
  .wrapper-number{
      display: flex;
      justify-content: center;
      margin-bottom: 1em;
  }
  .adv-counter .title-text{
      margin-top: 1em;
      font-family: 'Helvetica';
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 28px;
      text-align: center;
      
      color: #000000;
  }
  .text-number:first-child{
      border-radius: 20px 0px 0px 20px;
  }
  .text-number:last-child{
      border-radius: 0px 20px 20px 0px;
  }
  .adv-counter .text-number{
      font-family: 'Helvetica';
      font-style: normal;
      font-weight: 400;
      font-size: 100px;
      line-height: 1em;
      text-align: center;
      color: #000000;
      border: 1px solid #C4C4C4;
      padding: 6px;
  }
  @media (max-width: 1650px) {
    .adv-counter .text-number{
      font-size: 75px;
    }
  }
  @media (max-width: 1350px) {
    .adv-counter .text-number{
      font-size: 50px;
    }
  }
  @media (max-width: 850px) {
    .adv-counter .text-number{
      font-size: 40px;
    }
    .adv-counter .title-text{
      font-size: 12px;
      margin-top: 0;
      margin-left: 1em;
    }
    .wrapper-number{
      margin-bottom: 0em;
    }
    .adv-counter{
      place-items: center;
      display: flex;
      justify-content: flex-start;
    }
  }
</style>



// WEBPACK FOOTER //
// advCounter.vue?dfebc04a